(function(){
  var root=document.getElementById('heroCarousel');
  if(!root) return;
  var slides=[].slice.call(root.querySelectorAll('.hero-slide'));
  var video=document.getElementById('heroVideo');
  var caption=document.getElementById('heroCaption');
  var dotsBox=document.getElementById('heroDots');
  var IMAGE_HOLD=5000;
  var i=0, timer=null;

  var dots=slides.map(function(_,n){
    var b=document.createElement('button');
    b.className='hero-dot'+(n===0?' is-on':'');
    b.setAttribute('aria-label','切換到第 '+(n+1)+' 張');
    b.addEventListener('click',function(){ go(n); });
    dotsBox.appendChild(b);
    return b;
  });

  function go(n){
    clearTimeout(timer);
    i=n;
    slides.forEach(function(s,k){ s.classList.toggle('is-on',k===n); });
    dots.forEach(function(d,k){ d.classList.toggle('is-on',k===n); });
    caption.textContent=slides[n].getAttribute('data-caption')||'';
    if(slides[n].contains(video)){
      video.currentTime=0;
      var p=video.play();
      if(p&&p.catch) p.catch(function(){ timer=setTimeout(next,IMAGE_HOLD); });
    }else{
      video.pause();
      timer=setTimeout(next,IMAGE_HOLD);
    }
  }
  function next(){ go((i+1)%slides.length); }

  video.addEventListener('ended',next);
  video.addEventListener('error',function(){ go(1); });

  var started=false;
  var io=new IntersectionObserver(function(entries){
    entries.forEach(function(e){
      if(e.isIntersecting){ if(!started){ started=true; go(0); } }
      else { video.pause(); clearTimeout(timer); }
    });
  },{threshold:.25});
  io.observe(root);
})();

(function(){
  var LABELS=['正面','側面','背面'];
  var HOLD=4000;

  [].forEach.call(document.querySelectorAll('[data-shots]'),function(box){
    var shots=[].slice.call(box.querySelectorAll('.mi-shot'));
    if(shots.length<2) return;
    var row=box.closest('.model-row');
    var swatches=row?[].slice.call(row.querySelectorAll('.sw')):[];
    var nameOut=row?row.querySelector('.color-name'):null;
    var i=0, timer=null, hovering=false, visible=false;

    var tabs=document.createElement('div');
    tabs.className='mi-tabs';
    var btns=shots.map(function(_,n){
      var b=document.createElement('button');
      b.type='button';
      b.className='mi-tab'+(n===0?' is-on':'');
      b.textContent=LABELS[n]||('視角 '+(n+1));
      b.addEventListener('click',function(){ show(n); restart(); });
      tabs.appendChild(b);
      return b;
    });
    box.appendChild(tabs);

    function show(n){
      i=n;
      shots.forEach(function(s,k){ s.classList.toggle('is-on',k===n); });
      btns.forEach(function(b,k){ b.classList.toggle('is-on',k===n); });
    }
    function tick(){ if(!hovering) show((i+1)%shots.length); }
    function restart(){ clearInterval(timer); if(visible) timer=setInterval(tick,HOLD); }

    function setColor(btn){
      var base=btn.getAttribute('data-set');
      if(!base) return;
      shots.forEach(function(img,k){
        var set=(window.MS_SHOTS||{})[base];
        if(set&&set[k]) img.src=set[k];
        img.alt=(row?row.querySelector('.model-name').textContent.trim():'')+' '+
                btn.getAttribute('data-color')+'，'+LABELS[k];
      });
      swatches.forEach(function(s){ s.classList.toggle('is-on',s===btn); });
      if(nameOut) nameOut.textContent=btn.getAttribute('data-color')||'';
      show(0); restart();
    }
    swatches.forEach(function(s){
      s.addEventListener('click',function(){ setColor(s); });
      var pre=null;
      s.addEventListener('mouseenter',function(){
        if(pre) return;
        var set=(window.MS_SHOTS||{})[s.getAttribute('data-set')];
        if(!set) return;
        pre=new Image(); pre.src=set[0];
      });
    });

    box.addEventListener('mouseenter',function(){ hovering=true; });
    box.addEventListener('mouseleave',function(){ hovering=false; });

    new IntersectionObserver(function(es){
      es.forEach(function(e){
        visible=e.isIntersecting;
        if(visible) restart(); else clearInterval(timer);
      });
    },{threshold:.3}).observe(box);
  });
})();
